const IllumioSupportUtils = {
    isDebug: true,
    getLanguage: function() {
        const locale = navigator.language || navigator.userLanguage;
        if (locale.indexOf('-')>0) {
            const localeParts = locale.split('-');
            if (localeParts.length>1) {
                return localeParts[0];
            }
        } else if (locale) {
            return locale;
        }
        return 'en';
    },
    formatFileSize: function(fileSize) {
        if (!fileSize) {
            return '';
        } else if (fileSize >= 1073741824) {
            calcSize = fileSize / 1073741824.0;
            return Math.round(calcSize*100)/100 + 'GB';
        } else if (fileSize >= 1048576) {
            return Math.round(fileSize/1048576) + 'MB';
        } else if (fileSize >= 1024) {
            return Math.round(fileSize/1024) + 'KB';
        } else { // if (fileSize<1024) {
            return fileSize + ' bytes';
        }
    }, 
    /* Format integer with comma(s). */
    formatFileSizeInteger: function(fileSize) {
        if (fileSize) {
            const parts = fileSize.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }
        return '&nbsp;';
    },
    trackGaEvent: function(eventCategory, eventAction, eventLabel, eventValue) {
        // TODO: Replace with GA4 based on assessment on the needs.
    }, 
    trackGaException: function(exDescription, exFatal) {
        // TODO: Replace with GA4 based on assessment on the needs.
    }, 
    formatDate: function(date, showTime) {
        if (date) {
            const dateArray = [];
            dateArray.push(date.getUTCFullYear());
            dateArray.push(((date.getUTCMonth()+1<10) ? '0' : '') + (date.getUTCMonth()+1));
            dateArray.push(((date.getUTCDate()<10) ? '0' : '') + date.getUTCDate());
            
            if (showTime) {
                const dateTimeArray = []; 
                dateTimeArray.push(dateArray.join('-'));
                dateTimeArray.push(' ');
                let hour = date.getUTCHours();
                if (hour>12) {
                    hour -= 12;
                }
                dateTimeArray.push(((hour<10) ? '0' : '') + hour);
                dateTimeArray.push(':')
                dateTimeArray.push(((date.getUTCMinutes()<10) ? '0' : '') + date.getUTCMinutes());
                dateTimeArray.push(date.getUTCHours()<12 ? ' AM' : ' PM');
                return dateTimeArray.join('');
            }
            
            return dateArray.join('-')
        }
        return '';
    },
    /**
     * The Date object in JavaScript automatically convert UTC date into local timezone
     * based on the browser settings.
     *     For example, new Date('2023-09-01') auto converts to 
     *     Aug 31 2023 17:00:00 GMT-0700 (Pacific Daylight Time)
     * This function adjusts the date and returns date for display in UTC:
     *     September 1, 2023
     * The locale and options can further be overriden.
     * @param {*} date 
     */ 
    getUTCDisplayDate: function(date, locale='en-US',options={ year:'numeric', month: 'long', day:'numeric' }) {
        if (date) {
            const timeDifference = date.getTimezoneOffset() * 60000;
            const adjustedDate = new Date(date.valueOf()+timeDifference);
            return adjustedDate.toLocaleDateString('en-US', { year:"numeric", month:"long", day:"numeric"})
        }
    },
    listArgumentObject: function() {
        console.debug('Argument size: ' + arguments.length);
        for (let index=0;index<arguments.length;index++) {
            console.debug(arguments[index]);
        }
    }, 
    getJsonFromUrl: function(url_path) {
        const json = {};
        if (url_path) {
            url_path = url_path.replace(/#(.)*$/, '')
            const parts = url_path.split('?');
            if (parts.length>=2 && parts[1]) {
                const query = parts[1];
                const forEachHandler = function(part) {
                    const item = part.split('=');
                    json[item[0]] = decodeURIComponent(item[1]);
                }
                if (query.indexOf('&')>=0) {
                    query.split('&').forEach(forEachHandler);
                } else {
                    forEachHandler(query);
                }
            }
        }
        return json;
    },
    removeElement: function(theElement) {
        // --- Workaround for browser such as IE11 not supporting Element.remove(). 
        if (theElement && theElement.parentElement) {
            theElement.parentElement.removeChild(theElement);
        }
    },
    emptyElement: function(theElement) {
        let i = theElement.childNodes.length;
        while(i--) {
            theElement.removeChild(theElement.lastChild);
        }
    },
    getCookie: function(name) {
        const pairs = document.cookie.split(/;\s*/);
        for (let i=0;i<pairs.length;i++) {
            let nameValuePair = pairs[i].split(/=/);
            if (nameValuePair.length===2 && nameValuePair[0]===name) {
                return nameValuePair[1];
            }
        }
    },
    setCookie: function(name, value, domain, expires_in_days, path) {
        const cookieArray = [ name, '=', value, ';' ];
        
        if (expires_in_days) {
            const expires = new Date();
            expires.setTime(expires.getTime() + expires_in_days*62400000);
            cookieArray.push(expires);
            cookieArray.push(';');
        }
        if (domain) {
            cookieArray.push('domain=');
            cookieArray.push(domain);
            cookieArray.push(';');
        }
        if (path) {
            cookieArray.push('path=')
            cookieArray.push(path);
            cookieArray.push(';');
        }
        document.cookie = cookieArray.join('');
    },
    /* Return hash of array */
    // The input queryString may be location.search (starts with ?) or location.hash (starts with #)
    getParameters: function(queryString) {
        let parameters = null;
        if (queryString && queryString.length>1) {
            parameters = {};
            const foreachPairHandler = function(element, index, elements) {
                // Remove the + signs representing white space characters.
                // The + signs representing required keyword should have been encoded or escaped already.
                element = element.replace(/\+/g, ' ');
                const pairs = element.split('=');
                if (pairs.length>=2) {
                    const name = decodeURIComponent(pairs[0]);
                    const value = decodeURIComponent(pairs[1]);
                    if (name.match(/\[\]$/)) {
                        if (!parameters[name]) {
                            parameters[name] = new Array();
                        }
                        parameters[name].push(value);
                    } else {
                        parameters[name] = value;
                    }
                }
            }
            
            const queryStrings = queryString.substring(1).split('&');
            queryStrings.forEach(foreachPairHandler);
        }
        return parameters;
    },
    triggerResizeUIEvent: function() {
        const uiEvent = new UIEvent('resize', {
            view: window,
            detail: 0
        });
        window.dispatchEvent(uiEvent);
    },
    hideParentWithRow: function(theElement) {
        let parentElement = theElement;
        while (parentElement) {
            console.debug(parentElement);
            if (parentElement.classList.contains('row')) {
                parentElement.classList.add('hidden');
                break;
            }
            parentElement = parentElement.parentElement;
        } 
    },
    findItemFromArray: function(array, item) {
        // This is an alternative to Array.find() and Array.includes() which are not supported in Internet Explorer.
        if (array && item) {
            for (let i=0;i<array.length;i++) {
                if (array[i]===item) {
                    return true;
                }
            }
        }
        return false;
    },
    capitalizeWord: function(word) {
        if (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }
        return null;
    },
    camelCaseWords: function(words) {
        if (words) {
            const wordParts = words.split(' ');
            for (let i=0;i<wordParts.length;i++) {
                wordParts[i] = ((i===0) ? wordParts[i].charAt(0).toLowerCase() : wordParts[i].charAt(0).toUpperCase()) + wordParts[i].slice(1);
            }
            return wordParts.join('');
        }
        return null;
    },
    isPublicResource: function() {
        return (location.pathname.match(/\/shared\//)) ? true : false;
    },
} 

export default IllumioSupportUtils;